import { Injectable } from '@angular/core';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { ProgramModel } from '../models/program.model';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';
import { SharedParams } from 'src/app/@core/routes/shared-params.const';
import { Status } from 'src/app/@core/enums/status.enum';

@Injectable({
  providedIn: 'root',
})
export class CategoryService extends BaseFucntionsService<ProgramModel> {
  constructor(apiClient: ApiClientService) {
    super(ApplicationRoutes.Category.Categories, apiClient);
  }

  getShowInHomeDropDown() {
    return this.apiClient.get(`${this.urlPrefix}/${SharedParams.Dropdown}?showInHome=true`);
  }
}
